/**
 * 共通チャンク用エントリ（common-shared.js）
 * トップ・サブ両方で1回だけ読み込み、common-top.js / common-sub.js より前に読み込む
 */
require("./common/renewal2025-unified.js");
require("./common/modernizr-custom.js");
